export default __webpack_public_path__ + "static/media/gangdonggu-seongnaedong-station-activation-1.7a0c8fc7.jpg";